import React, { useEffect, useState } from "react";
import { API_URL, GET_SALES_REPORT_COUNTRIES } from "../../../constants";
import { GET_PERCENTAGE, GET_TOKEN, CURRENCY } from "../../../helpers";
import { LoadingSpinner } from "../partials/LoadingSpinner";
import { EmptyData } from "../../Global/EmptyData/EmptyData";
import "./WidgetGraphSalesByCountry.css";

export const WidgetGraphSalesByCountry = (props) => {
  const [countrySales, setCountrySales] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    setDataLoaded(false);
    let hasDates = props?.filterPayload?.from || props?.filterPayload?.to;
    

    const generateString = () => {
      let resultString = "/?";
      
      const querryString = {
        from:
            (props.filterPayload && props.filterPayload.from) &&
            props.filterPayload.from.getFullYear() +
            "-" +
            ( props.filterPayload.from.getMonth() + 1) +
            "-" +
            props.filterPayload.from.getDate(),
        to:
            (props.filterPayload && props.filterPayload.to) &&
            props.filterPayload.to.getFullYear() +
            "-" +
            ( props.filterPayload.to.getMonth() + 1) +
            "-" +
            props.filterPayload.to.getDate(),
      };

      //eslint-disable-next-line
      Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
        if (fieldItemValue !== undefined && fieldItemValue !== null) {
          return (resultString = resultString.concat(`${fieldItem}=${fieldItemValue}&`));
        }
      });

      return resultString;
    }

    fetch(
      API_URL +
        GET_SALES_REPORT_COUNTRIES +
        generateString() +
        `region=${props.countryFilter || 'all'}&` +
        ((props.globalDays && !hasDates) ? `days=${props.globalDays}&` : '') + 
        (props.globalCurrency && `currency=${props.globalCurrency}&`)
        , {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
    .then((response) => response.json())
    .then((response) => setCountrySales(response))
    .then(() => setDataLoaded(true));
    
  // eslint-disable-next-line
  }, [props.globalCurrency, props.globalDays, props.countryFilter, props.filterPayload])

  const listOfCountires = () => {
    return countrySales.map((item, index) => {
      return (
        <div className="country-item" key={index}>
          <div className="country-item__info">
            <div className="country-item__name flex-align-center">
              {item.img && <img src={item.img} className="flag-icon-img" alt={item.name}/>}
              {item.name}
            </div>

            {item.tresholdLimit && (
              <div className="country-item__treshold">
                Treshold limit exceeded

                <div className="icon error-icon-two"></div>
              </div>
            )}
          </div>
          <div className="country-item__price">
            <div className="country-item__current-price">{CURRENCY(item.price, item.currency_symbol)}</div>
            <div
              className={
                "country-item__changed-price " +
                (item.differenceType ? "positive" : "negative")
              }
            >
              <span>
                {(item.differenceType ? "+ " : "- ") + " "}
              </span>

              {CURRENCY(item.difference, item.currency_symbol)}

              {
                item.differencePercent && (
                  <span>
                    {`(${item.differencePercent}%)` }
                  </span>
                )
              }
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="Salesreport__sales-by-country widget half-width-dashboard">
        <h2> Sales by country </h2>

        {countrySales.length > 0 && dataLoaded === true ? (
          <div className="border widget-content">{listOfCountires()}</div>
          ) : dataLoaded 
              ? <EmptyData title="No sales data in selected period found" />
              : <LoadingSpinner/>
            }
      </div>
    </>
  );
};
